'use strict';

var _levels = require('./levels');

var _levels2 = _interopRequireDefault(_levels);

var _events = require('events');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 */

function Logger() {
    var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _events.EventEmitter.call(this);
    Object.assign(this, properties);

    this._silent = properties.silent !== undefined ? properties.silent : false;
}

/**
 */

Object.assign(Logger.prototype, _events.EventEmitter.prototype, {

    /**
     */

    level: _levels2['default'].ALL,

    /**
     */

    track: function track() {
        this.emit.apply(this, ['track'].concat(Array.prototype.slice.call(arguments)));
    },
    setSilent: function setSilent(silence) {
        this._silent = silence;
    },
    getSilent: function getSilent() {
        return this._silent;
    }
});

/**
 * attach the notice, error, warn, info, verbose methods
 */

Object.keys(_levels2['default']).forEach(function (key) {
    var code = _levels2['default'][key];
    if (!(code & _levels2['default'].NONE)) {
        var type = key.toLowerCase();
        Logger.prototype[type] = function () {
            if (!(this.level & code)) return;
            this.emit('log', {

                // add english term to log
                type: type,

                // maintain consistent property
                level: code,

                // don't do anything to the arguments
                args: Array.prototype.slice.call(arguments, 0),

                // Allow for logs to be silent and now output anything to the
                // console.  This allows for testing the logger without making a
                // bunch of noise in the test output.
                silent: this.getSilent()
            });
        };
    }
});

Logger.create = function (properties) {
    return new this(properties);
};

module.exports = new Logger();
module.exports.Logger = Logger;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/logger/index.js
 ** module id = 482
 ** module chunks = 0 1
 **/